import { useFetchError } from 'components/useFetchError/useFetchError'
import { SchemaModel, schemaModels } from '@schematicos/types'
import { useEffect, useRef, useState } from 'react'
import { supabaseClient } from 'lib/supabaseClient/supabaseClient'

export const useGetSchemas = () => {
  const { handleFetchError } = useFetchError()
  const [schemas, setSchemas] = useState<SchemaModel[]>()
  const loadingRef = useRef(false)

  useEffect(() => {
    if (loadingRef.current) {
      return
    }

    loadingRef.current = true

    void supabaseClient.functions
      .invoke('schemas', { method: 'GET' })
      .then(({ data, error }) => {
        if (error) {
          throw error
        }

        const parsed = schemaModels.parse(data)

        setSchemas(parsed)
      })
      .catch(handleFetchError('Failed to retrieve schemas'))
      .finally(() => (loadingRef.current = false))
  }, [])

  return {
    data: schemas,
    loading: loadingRef.current
  }
}
